import type { GetProductResponse } from '@vue-storefront/prestashop-api';
import { useSdk } from '~/sdk';

interface ProductState {
  data: GetProductResponse['psdata'] | null;
  pending: boolean;
  error: Error | null;
}

export const useProduct = () => {
  const key = useKey();
  const { t } = useI18n();
  const state = useState<ProductState>(`${key.value}-product`, () => ({
    data: null,
    pending: false,
    error: null,
  }));
  const sdk = useSdk();


  async function fetchProduct() {
    state.value.pending = true;

    const { id, slug, groupId, attributeId } = useProductParams();

    const data = await sdk.commerce.getProduct({ id, groupId, attributeId });

    // If no data, product doesn't exist
    if (!data) {
      throw createError({
        statusCode: 404,
        message: t('Product not found'),
      });
    }

    // Handle product redirects
    if (data.redirect) {
      if (data.redirect.type === '301') {
        await navigateTo(data.redirect.to, {
          redirectCode: parseInt(data.redirect.type),
        });
      } else if (data.redirect.type === '302'){
        await navigateTo(data.redirect.to, {
          redirectCode: parseInt(data.redirect.type),
        });
      }
      else if (data.redirect.type === '404') {
        throw createError({
          statusCode: 404,
          message: t('Product not found'),
        });
      }
    }

    // Check if product is active (for non-redirect cases)
    if (!data.active || data.active == '0') {
      throw createError({
        statusCode: 404,
        message: t('Product not found'),
      });
    }

    state.value.pending = false;
    state.value.data = data;
  }

  return {
    data: computed(() => state.value.data),
    pending: computed(() => state.value.pending),
    error: computed(() => state.value.error),
    refresh: fetchProduct,
    execute: fetchProduct,
  };
};
